import { ref, provide, onMounted, onBeforeUnmount } from 'vue'

const MOBILE_MQ = '(max-width: 1024px)'

export function useMobileResponsive() {
  const isMobile = ref(false)

  let mql: MediaQueryList | null = null
  const sync = () => {
    isMobile.value = !!mql?.matches
  }

  onMounted(() => {
    if (typeof window === 'undefined') return
    mql = window.matchMedia(MOBILE_MQ)
    sync()
    mql.addEventListener('change', sync)
  })

  onBeforeUnmount(() => {
    mql?.removeEventListener('change', sync)
  })

  provide('isMobile', isMobile)

  return { isMobile }
}
